module.exports = __webpack_public_path__ + "media/images/shared/icon_food_black-c867e63a53e2762dcbe6582d0c63dff9.png";